"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Jakub Gereg
 */

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var SalesDashboardExcelFile =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SalesDashboardExcelFile, _DomainObject_1$Domai);

  /**
   * Creates new instance of SalesDashboardExcelFile.
   * @param id ID of the SalesDashboardExcelFile
   * @param fileId ID of the file
   * @param note note
   */
  function SalesDashboardExcelFile(id, fileId, note) {
    var _this;

    _classCallCheck(this, SalesDashboardExcelFile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardExcelFile).call(this));
    _this.id = id;
    _this.fileId = fileId;
    _this.note = note;
    return _this;
  }

  return SalesDashboardExcelFile;
}(DomainObject_1.DomainObject);

exports.SalesDashboardExcelFile = SalesDashboardExcelFile;

SalesDashboardExcelFile.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SalesDashboardExcelFile.name);
  return {
    id: builder.id('id'),
    fileId: builder.str('fileId'),
    note: builder.opt(builder.str('note'))
  };
}();